import React from "react";
import "./style.scss";
import Button from "components/BaseWidgets/button/index";

function CompleteProfileCard({
  buttonText,
  cardContent,
  cardImage,
  onOk,
  href,
}) {
  return (
    <div className="profile-card">
      <div className="profile-card-image">
        <img src={cardImage} alt={`img`} />
      </div>
      <div className="flex flex-col gap-4">
        <p className="profile-card-content font-title-xs fw-500">
          {cardContent}
        </p>
        <Button
          className="mt-auto add-btn"
          href={href}
          onClick={onOk}
          variant="coloured"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
}

export default CompleteProfileCard;
